import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// One-time session_id -> session_token exchange. No loading UI per the
// auth playbook -- it should feel instant, then land back on the app.
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { completeLogin } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace('#', ''));
    const sessionId = params.get('session_id');

    const finish = () => {
      window.history.replaceState(null, '', window.location.pathname);
      navigate('/', { replace: true });
    };

    if (!sessionId) {
      finish();
      return;
    }
    completeLogin(sessionId).then(finish).catch(finish);
  }, [completeLogin, navigate]);

  return null;
}
